import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2。TipTap は編集画面を開いたときだけ読み込まれる） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

const nativeWikiRoutes: RouteObject[] = [
  { path: '/manual/*', lazy: page(() => import('./pages/SpaceListPage.js')) },
  { path: '/manual', lazy: page(() => import('./pages/SpaceListPage.js')) },
  { path: '/wiki/*', lazy: page(() => import('./pages/SpaceListPage.js')) },
  { path: '/wiki', lazy: page(() => import('./pages/SpaceListPage.js')) },
  { path: '/wiki/search', lazy: page(() => import('./pages/WikiSearchPage.js')) },
  { path: '/wiki/reviews', lazy: page(() => import('./pages/ReviewInboxPage.js')) },
  { path: '/wiki/spaces/:spaceId', lazy: page(() => import('./pages/SpacePage.js')) },
  { path: '/wiki/spaces/:spaceId/new', lazy: page(() => import('./pages/NewPagePage.js')) },
  { path: '/wiki/spaces/:spaceId/settings', lazy: page(() => import('./pages/SpaceSettingsPage.js')) },
  { path: '/wiki/pages/:pageId', lazy: page(() => import('./pages/PageViewPage.js')) },
  { path: '/wiki/pages/:pageId/edit', lazy: page(() => import('./pages/PageEditPage.js')) },
  { path: '/wiki/pages/:pageId/history', lazy: page(() => import('./pages/PageHistoryPage.js')) },
];

export const wikiRoutes: RouteObject[] = [
  { lazy: page(() => import('./pages/WikiBackendPage.js')), children: nativeWikiRoutes },
];
